import { createStore } from '../core/state/store';

/**
 * Unread-count badges for the shell's bottom tab bar, keyed by tab id.
 * Separate from the `GameTab` interface on purpose: the count is produced by
 * the notification poller (notifications.ts), not by the tab module that
 * displays it, so a store is the natural seam — `shell.ts` subscribes once
 * at mount, no tab needs to know badges exist.
 */
export const tabBadgeStore = createStore<Record<string, number>>({});

/** No-op if the count hasn't actually changed — createStore already short-circuits on reference equality, but building a fresh object every poll would defeat that, so check first. */
export function setTabBadge(tabId: string, count: number): void {
  const current = tabBadgeStore.get();
  if ((current[tabId] ?? 0) === count) return;
  tabBadgeStore.set({ ...current, [tabId]: count });
}

/** Call on logout/teardown — a module-level store would otherwise leak the previous user's badge count into the next session. */
export function resetTabBadges(): void {
  tabBadgeStore.set({});
}
